import { AxiosRequestConfig } from 'axios'

export interface WelcomeRewardUsesParams {
  endDate: string // Format: YYYY-MM-DD
  storeId?: number
}

export interface WelcomeRewardUsesData {
  month: string // Format: YYYY-MM
  percentage: number
  totalRegisteredUsers: number
  totalConsumedWelcomeRewards: number
}

export interface WelcomeRewardUsesResponse {
  data: WelcomeRewardUsesData[]
}

const getWelcomeRewardUses = (params: WelcomeRewardUsesParams): AxiosRequestConfig => ({
  url: '/dashboard/welcome-reward-uses',
  method: 'GET',
  params,
})

export { getWelcomeRewardUses }
